import { Localizable } from '@components/localizable/Localizable'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  createLegalDocumentVersion,
  deleteLegalDocumentVersion,
} from '@store/LegalDocumentVersionReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import { useParams } from 'react-router-dom'
import Create from './Create'
import Delete from './Delete'

export const LegalDocumentVersionForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const { legalDocumentSlug } = useParams()
    const dispatch = useAppDispatch()
    const { error } = useAppSelector((state) => state.legalDocumentVersion)

    if (!legalDocumentSlug) return

    return (
      <Localizable>
        <SBRM.BaseEntityForm
          {...{ ref, formProps }}
          error={error && String(error)}
          formActions={{
            create: Create,
            delete: Delete,
          }}
          handlers={{
            create: async (values) =>
              dispatch(
                createLegalDocumentVersion(legalDocumentSlug, values)
              ).then(() => {
                return true
              }),
            delete: async (values) =>
              dispatch(
                deleteLegalDocumentVersion(legalDocumentSlug, values)
              ).then(() => {
                return true
              }),
          }}
        />
      </Localizable>
    )
  }
)

LegalDocumentVersionForm.displayName = 'LegalDocumentVersionForm'

export default LegalDocumentVersionForm
